export const information = [
    {
        id : 1,
       hospitalName : "Mayo Clinic",
       hospitalLocation : "united state",
        hospitalimage : "https://cdn2.hubspot.net/hubfs/465692/mc-banner2-1-1.jpg"
    },
    {
        id : 2,
       hospitalName : "Sarasota Memorial Hospital",
       hospitalLocation : "united state",
        hospitalimage : "https://www.heraldtribune.com/gcdn/presto/2021/03/04/NSHT/bc0b3df6-b355-4122-b82f-691c22ebf43a-FLSAR-030521-S_SMHRATING01.jpg"
    },
    {
        id : 3,
       hospitalName : "John Hopkins Hospital",
       hospitalLocation : "united state",
        hospitalimage : "https://api.hub.jhu.edu/factory/sites/default/files/styles/landscape/public/ncb.jpg"
    },
    {
        id : 4,
       hospitalName : "Anne Arundel Medical Center",
       hospitalLocation : "united state",
        hospitalimage : "https://living.aahs.org/wp-content/uploads/AAMC-Hospital-Exterior-blog-1050x575.jpg"
    },
    {
        id : 5,
       hospitalName : "Memorial Hospital",
       hospitalLocation : "united state",
        hospitalimage : "https://wearememorial.com/wp-content/uploads/2022/08/D75_7357-1-1200x607.jpg"
    },
    {
        id : 6,
       hospitalName : "karolinska",
       hospitalLocation : "united state",
        hospitalimage : "https://www.universitymagazine.ca/wp-content/uploads/2020/12/karolinska-universitetssjukhuset.jpg"
    },
    {
        id : 7,
       hospitalName : "Erdogan Hospital",
       hospitalLocation : "Mogadisho ' somalia",
        hospitalimage : "https://c.files.bbci.co.uk/98B7/production/_111759093_52020595_236498200476301_6409639236399529984_o.jpg"
    },
    {
        id : 8,
       hospitalName : "Banaadir Hospital",
       hospitalLocation : "Mogadisho ' somalia",
        hospitalimage : "https://scontent.fmgq2-1.fna.fbcdn.net/v/t1.6435-9/159904827_1805464446269693_3134866913717645401_n.jpg?_nc_cat=107&cb=99be929b-3346023f&ccb=1-7&_nc_sid=8bfeb9&_nc_ohc=rXClObBODzAAX_TyUdh&_nc_ht=scontent.fmgq2-1.fna&oh=00_AfBEtlPxXe28fnks0Hc0zFay3svZiK-gf1CdOddbsZHQqA&oe=64ECF18F"
    },
    {
        id : 9,
       hospitalName : "University Hospital Viena",
       hospitalLocation : "united state",
        hospitalimage : "https://www.meduniwien.ac.at/web/fileadmin/_processed_/b/f/csm_180817_CH_H4130_524ec136ca.jpg"
    }
]
